jQuery( document ).ready( function( $ ) {
 
  
  /* ---- Header > Logo Small ---- */  
  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $('.site-header').addClass('user-scrolled');
        } else {
            $('.site-header').removeClass('user-scrolled');
        }
    });
  
  
  /* ---- Header > Hambuger ---- */  
  
  $('.hamburger').click(function(e){

    $('.site-header .mobile-menu').slideToggle();
    
    e.preventDefault();
  });
  
  /* ---- Home > Videos ---- */  

//   $(".home-videos .image").click(function(e) {
//     e.preventDefault();
//     $(this).addClass('active');
//     $currentVideo = $(this).attr("data-src");
//     $(this).siblings().find('iframe').attr('src', $currentVideo);
//     $(this).next('.videoWrapper').show();
//   });
 

  /* ---- Home > Gallery ---- */  

  $('.home-gallery .slick-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,          
          autoplay: false,
          autoplaySpeed: 7000,          
        }
      
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]     
  });
  
  
  /* ---- Home > Gear ---- */  
  
  $('.home-gear .slick-slider').slick({
    dots: false,
    arrows:false,
    autoplay: false,
    autoplaySpeed: 7000,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: false,
          autoplaySpeed: 7000,          
        }
      
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]    
  });   
  
  
  /* ---- Photos > Masonry ---- */  
  
  
  // with jQuery
  var $container = $('.masonry-overview .grid');

  // initialize Masonry after all images have loaded  
  $container.imagesLoaded( function() {
    $container.masonry({
    // options
    itemSelector: '.grid-item',
    percentPosition: true
  });
  });  


});